import {useTranslation} from "react-i18next";


import 'moment-timezone';


const labelsDefault = [
    {"label": "", "required": true},
    {"label": "common.plugin", "required": true},
    {"label": "common.actions", "required": true},
]


const TablePlugins = (props) => {
    const [t] = useTranslation("tables")
    const callbacksNames = {
        mqttin: t("plugins.mqttin"),
        inventory: t("plugins.inventory")
    }


    return (
        <table className="table table-striped">
            <thead>
            <tr>
                {
                    labelsDefault.map((item, idx) => (
                        <th key={idx}>{t(item.label)}</th>
                    ))
                }
            </tr>
            </thead>
            <tbody>
            {props.items.map((item, index) => (
                <tr key={index}>
                    <td style={{verticalAlign: "middle"}}>
                        <input type="radio" name="callback" data-idx={index} value={item.key} onChange={props.onClickRow}/>
                    </td>
                    <td>
                        <div className="card-table">

                            <img src={`/media/plugins/${item.slug}/image.png`} style={{width: "200px"}} alt="logo callback"/>
                            <h3 className="mt-3">{item.name}</h3>
                            <p>{item.description}</p>

                        </div>
                    </td>
                    <td style={{verticalAlign: "middle"}}>
                        <ul>
                            <li>KEY: {item.key}</li>
                            {item.callbacks.map((call, idx) => (
                                <li key={idx}>
                                    {callbacksNames[call]}
                                </li>
                            ))}
                        </ul>
                    </td>

                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TablePlugins

